import React from "react";
import "./plan-card.scss";
import { Col } from "reactstrap";
import InnerShadowButton from "../../buttons/innerShadow";

class PlanCard extends React.Component {
  state = {
    device: "mobile"
  };
  componentDidMount() {
    this.setState({
      device: window.screen.availWidth < 850 ? "mobile" : "web"
    });
  }
  render() {
    return (
      <Col lg="6" className="m-0 p-0 text-center">
        <div
          className={
            "plan-item-card text-center cursor-pointer " +
            this.props.data.plan +
            " " +
            (this.props.active && " active")
          }
          onClick={e => {
            e.preventDefault();
            this.props.onClickCard(this.props.data.plan);
          }}
        >
          <div className="card-title-box d-flex justify-content-center align-items-center ">
            <img
              className={"card-icon " + this.props.data.plan}
              src={this.props.data.icon}
              alt=""
            />
            <div className="text-left">
              <h2 className="m-0">{this.props.data.title}</h2>
              <h3>Toffee Plan</h3>
            </div>
          </div>
          <h3 className="card-sub-title text-center">
            {this.props.data.subTitle}
          </h3>
          <div className="rate-box text-center">
            <h3 className="card-sub-title text-center p-0 m-0">
              Starting From
            </h3>
            <p className="p-0 m-0 value">₹{this.props.data.rate}</p>
            <p className="p-0 m-0 per">Per Month</p>
          </div>
          <InnerShadowButton
            clicked={e => {
              //   this.moveToProducts();
              this.props.onClickButton(e);
            }}
            title="KNOW MORE"
            active={this.props.active}
          />
          <hr />
          <h3 className="text-center font-weight-bold mb-32">
            {this.props.data.benifits}
          </h3>
          <div className="bottom-list">
            {this.props.data.included.map((item, index) => {
              return (
                <div
                  key={"benifit-" + index}
                  className="d-flex align-items-start bottom-list-item"
                >
                  <div className="dot opacity-80"></div>
                  <h3 className="text-left p-0 m-0">{item}</h3>
                </div>
              );
            })}
          </div>
          <div className="info-label">
            COVERS COVID-19 (CORONA VIRUS) PANDEMIC
          </div>
        </div>
      </Col>
    );
  }
}

export default PlanCard;
